module.exports = __webpack_public_path__ + "static/media/jeans.b54d25bc.jpg";